import { Typography, Box, CircularProgress, Divider, Button, Stack, OutlinedInput, InputAdornment } from "@mui/material"
import { useState, useRef, useEffect, useContext } from "react"
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import { GenerateBill } from "../../global/API"
import moment from "moment"
import { ToolContext } from "../../../../core/context/ToolContext"
import { env } from "../../../../core/Env"
import { CstmSnackBar } from "../../../../core/global/forms/CstmSnackBar";

export const Index = () => {

const [transaction, setTransaction] = useState(null)
const [inputValue, setInputValue] = useState("")
const [discount, setDiscount] = useState(0)
const [isScanning, setIsScanning] = useState(false)
const [isProcessing, setIsProcessing] = useState(false)
const [billItems, setBillItems] = useState([])
const [billLoading, setBillLoading] = useState(false)
const [snackBarLoader, setSnackBarLoader] = useState({snackbar:false, msg:'', type:''})


const {session_state, tool_state} = useContext(ToolContext)
const { sessionData } = session_state
const { __SESSION } = tool_state

const inputRef = useRef(null)
const today = moment().format("YYYY-MM-DD");


useEffect(() => {
    inputRef.current?.focus()
}, [])

    const handleDecode = () => {
        try {
        const decoded = atob(inputValue.trim())
        const parsed = JSON.parse(decoded)
        console.log(parsed);
        if (parsed) {
            setTransaction(parsed)
            setIsScanning(false)
            setInputValue("")
            FetchBill(parsed)
        }
        } catch (error) {
        setInputValue("")
        setSnackBarLoader({...snackBarLoader, snackbar:true, msg: `Try Again!`, type: 'error'})
        console.error("Invalid QR payload")
        setIsScanning(false)
        }
    }

    const handleChange = (e) => {
        if (!isScanning) setIsScanning(true)
        setInputValue(e.target.value)
    }

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
        e.preventDefault()
        handleDecode()
        }
    }
    
    const FetchBill = async (transaction) => {
    
        try {
            setBillLoading(true)

            let qsp = {
                from: transaction.check_in_date ? transaction.check_in_date : today,
                to: today,
                code: transaction.name,
                branch_id: sessionData.data.branch_id,
                company_id: __SESSION.data.uaccess[0].company_id
            }

            let res = await GenerateBill(qsp)

            if (res) {
                setBillItems(res)
            }else{
                setBillLoading(false)
            }

        } catch (error) {
            console.error(error)
        } finally {
            setBillLoading(false)
        }
    }

    const total = billItems.reduce(
        (sum, item) => sum + parseFloat(item.total_amount),
        0
    )

    const handleCheckout = async () => {

        if (!transaction.uid){
            setTransaction(null)
            return
        }

        try {
        setIsProcessing(true)

        const response = await fetch(`https://s7iqwt4oi1.execute-api.ap-southeast-1.amazonaws.com/${env()}/booking/update_status`, {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            "x-api-key": 'ollKzRISKs5uhyw4dbKVQ8x38u2zLZ047u5N7RUc',
            },
            body: JSON.stringify({
                order_id: transaction.tid,
                user_id: transaction.uid,
            }),
        })

        const result = await response.json()
        console.log("Checkout response:", result)

        setTransaction(null)
        inputRef.current?.focus()

        } catch (error) {
        console.error("Checkout failed:", error)
        } finally {
        setIsProcessing(false)
        }
    }

    const handleBoxClick = () => {
        inputRef.current?.focus()
    }

    const handleDiscountChange = (e) => {
        const value = e.target.value;
        const regex = /^(0|[1-9]\d*)(\.\d*)?$/;

        if (!regex.test(value) && value !== "") {
            return;
        } 

        setDiscount(value);
    };

    return !transaction ? (
        <Box
        onClick={handleBoxClick}
        sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: 2,
            p: 4,
            width: "80%",
            maxWidth: "300px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
        }}
        >
        <Typography>Scan QR Code to Bill Out</Typography>

        <QrCodeScannerIcon sx={{ fontSize: 100, my: 2, color: "primary.main" }} />

        {isScanning && (
            <>
            <Typography color="text.secondary">
                Please wait...
            </Typography>
            <CircularProgress size={28} />
            </>
        )}

            
        <input ref={inputRef} inputMode="none" autoFocus value={inputValue} onChange={handleChange} onKeyDown={handleKeyDown} style={{ position: "absolute", opacity: 0, height: 0, width: 0}}/>
        {snackBarLoader.snackbar && (
            <CstmSnackBar value={snackBarLoader} setter={setSnackBarLoader} msg={snackBarLoader.msg} type={snackBarLoader.type} /> 
        )}
        </Box>
    ) : (
        <Box
            sx={{
                my: "10%",
                mx: "auto",
                bgcolor: "#fff",
                p: 5,
                fontFamily: "monospace",
                height: "90%",
                width: "100%",
                maxWidth: "500px",
                display:"flex",
                flexDirection: "column",
                justifyContent: "space-between",
            }}
        >
            <Box>
                <Stack mb={2}>
                    <Typography variant="h6" align="center">
                        MIRA Agropark
                    </Typography>
                    <Typography fontStyle="italic" align="center" gutterBottom>
                        Sitio Ibucao, Tanay, Rizal
                    </Typography>
                
                    <Typography variant="body2">
                        Date: {today}
                    </Typography>             

                    <Typography variant="body2">
                        Name: {transaction.name}
                    </Typography>
                </Stack>

                <Divider sx={{ mb: 2 }} />

                <Typography variant="h6" align="center" gutterBottom>
                    STATEMENT OF ACCOUNT
                </Typography>
                <Divider sx={{ my: 2 }} />
            {billLoading ? (
                <Box textAlign="center">
                    <CircularProgress size={28} />
                </Box>
            ) : (
                    <Box>
                        {billItems.map((item, index) => (
                            <Box key={index} mb={1}>
                                <Typography variant="body2">
                                    {item.alias}
                                </Typography>
                                <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    fontSize="0.85rem"
                                >
                                    <span>
                                        {item.total_quantity} x
                                    </span>
                                    <span>
                                        ₱{parseFloat(item.total_amount).toFixed(2)}
                                    </span>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                    
                )}
            </Box>
            <Box> 
                <Box sx={{display: "flex", gap: 2, alignItems: "center", justifyContent: "space-between"}}>
                    <Typography>
                        Discount
                    </Typography>
                    <OutlinedInput sx={{width: "150px"}} inputProps={{textAlign: "right"}} value={discount} onChange={(e)=>{handleDiscountChange(e)}} endAdornment={<InputAdornment position="end">%</InputAdornment>}/>
                </Box>
                <Divider sx={{ my: 2 }} />

                <Box display="flex" justifyContent="space-between">
                    <Typography>
                        Total
                    </Typography>
                    <Typography >
                        ₱{total.toFixed(2)}
                    </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between">
                    <Typography>
                        Down payment
                    </Typography>
                    <Typography>
                        - ₱{parseFloat(transaction.dp ? transaction.dp : 0).toFixed(2)}
                    </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between">
                    <Typography>
                        Discount
                    </Typography>
                    <Typography>
                        - ₱{(total * (discount / 100)).toFixed(2)}
                    </Typography>
                </Box>
                <Box display="flex" justifyContent="space-between">
                    <Typography fontWeight="bold" variant="h6">
                        Net for Payment
                    </Typography>
                    <Typography fontWeight="bold" variant="h6">
                            ₱{
                                (total - (parseFloat(transaction.dp ? transaction.dp : 0) + (total * (discount / 100)))).toFixed(2) > 0 ?
                                    (total - (parseFloat(transaction.dp ? transaction.dp : 0) + (total * (discount / 100)))).toFixed(2)
                                :
                                    0.00
                            }
                    </Typography>
                </Box>
                <Divider sx={{ my: 2 }} />
                <Button
                    variant="contained"
                    fullWidth
                    onClick={handleCheckout}
                    disabled={isProcessing}
                    sx={{
                        px: 3,
                        borderRadius: 2
                    }}
                >
                    {isProcessing ? "Processing..." : "Checkout"}
                </Button>
            </Box>

        </Box>
    )
}